<div class="card-body">
    <div id="apex-column-with-negative-values"></div>
</div>